export default function MySQL_CURRENT_DATE() {
  return (
    <div>
      <h2>MySQL_CURRENT_DATE</h2>    </div>
  );
}